const MobileSkeleton = () => {
  return (
    <section className="mx-auto max-w-3xl p-4">
      {/* Title Skeleton */}
      <div className="mb-4 h-6 w-48 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>

      {/* Featured Article Skeleton */}
      <div className="mb-6 h-64 animate-pulse overflow-hidden rounded-lg bg-gray-300 dark:bg-gray-700"></div>

      {/* Other Articles Skeleton */}
      <div className="space-y-4">
        {[...Array(3)].map((_, idx) => (
          <div
            key={idx}
            className="flex animate-pulse items-center rounded-lg bg-gray-100 p-4 shadow-sm dark:bg-gray-800"
          >
            {/* Image Skeleton */}
            <div className="mr-4 h-20 w-24 rounded-lg bg-gray-300 dark:bg-gray-700"></div>

            {/* Text Skeleton */}
            <div className="flex-grow space-y-2">
              <div className="h-4 w-3/4 rounded-md bg-gray-300 dark:bg-gray-700"></div>
              <div className="h-3 w-1/2 rounded-md bg-gray-300 dark:bg-gray-700"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MobileSkeleton;
